import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { NCashData } from "../../../model/finzy-flex/nCash.model";
import { LrsList } from "../../../model/finzy-flex/lrs-list.model";
import { LenderAccountInfo } from "../../../model/finzy-flex/lender-account.model";
import { ConfigService } from "../../config.service";
import { WithdrawMoneyRequest } from "../../../model/finzy-flex/withdraw-money.model";
import { LenderProductWisePo } from "../../../model/LenderProductWisePo.mode";

@Injectable()
export class AccountService {
    private readonly httpClient: HttpClient;
    private readonly configService: ConfigService;

    constructor(httpClient: HttpClient, configService: ConfigService) {
        this.httpClient = httpClient;
        this.configService = configService;
    }

    public async getLenderAccountInfo(lenderId: string): Promise<LenderAccountInfo> {
        const url = `${this.configService.getAccountServiceUrl()}/account/${lenderId}/info`;
        return await this.httpClient.get<LenderAccountInfo>(url).toPromise();
    }

    public async getLenderProductWisePo(lenderId: string): Promise<LenderProductWisePo> {
        const url = `${this.configService.getAccountServiceUrl()}/account/${lenderId}/sub-product-wise-po`;
        return await this.httpClient.get<LenderProductWisePo>(url).toPromise();
    }

    public async getNCashDetails(lenderId: string, nCashType?: string, ncashFrequency?: string, ncashDateSelection?: number): Promise<NCashData> {
        const url = `${this.configService.getAccountServiceUrl()}/account/nCash/${lenderId}`;
        const nCashQueryParams = this.getNCashQueryParams(nCashType, ncashFrequency, ncashDateSelection);
        return await this.httpClient.get<NCashData>(url, { params: nCashQueryParams }).toPromise();
    }

    public async downloadLrs(lenderId: string, fromDate?: Date, toDate?: Date, frequency?: string, productCode?: string) {
        let params = {};
        params = this.getParams(fromDate, toDate, frequency, productCode);
        const url = `${this.configService.getAccountServiceUrl()}/account/${lenderId}/download/lrs`;
        return await this.httpClient.get(url, { params: params, responseType: 'blob' }).toPromise();
    }

    public async accountStatementDownload(lenderId: string, profileId: string) {
        let params = new HttpParams();
        params.set('profile_id', profileId)
        const url = `${this.configService.getAccountServiceUrl()}/reporting/${lenderId}/account-statement`;
        return await this.httpClient.get(url, { params, responseType: 'blob' }).toPromise();
    }

    public async getLrsListData(lenderId: string, fromDate?: Date, toDate?: Date, frequency?: string, productCode?: string): Promise<LrsList> {
        let params = {};
        params = this.getParams(fromDate, toDate, frequency, productCode);
        const url = `${this.configService.getAccountServiceUrl()}/account/${lenderId}/lrs`;
        return await this.httpClient.get<LrsList>(url, { params: params }).toPromise();
    }

    public async downloadInterestCertificate(financialYear: string, lenderId: string) {
        let params = new HttpParams().set('financialYear',financialYear).set('lenderId',lenderId);
        const url = `${this.configService.getAccountServiceUrl()}/reporting/download-interest-certificate`;
        return await this.httpClient.get(url, {params: params, responseType: 'blob'}).toPromise();
    }

    public async downloadStatementOfReturns(financialYear: string, lenderId: string) {
        let params = new HttpParams().set('financialYear',financialYear).set('lenderId',lenderId);
        const url = `${this.configService.getAccountServiceUrl()}/reporting/download-statement-of-return`;
        return await this.httpClient.get(url, {params: params, responseType: 'blob'}).toPromise();
    }

    private getParams(fromDate?: Date, toDate?: Date, frequency?: string, productCode?: string) {
        let params = {};
        if (fromDate) {
            params['fromDate'] = fromDate;
        }
        if (toDate) {
            params['toDate'] = toDate;
        }
        if (frequency) {
            params['frequency'] = frequency;
        }
        if (productCode) {
            params['productCode'] = productCode;
        }
        return params;
    }

    private getNCashQueryParams(ncashType?: string, ncashFrequency?: string, ncashDateSelection?: number) {
        let params = {};
        if (ncashType) {
            params['ncashType'] = ncashType;
        }
        if (ncashFrequency) {
            params['ncashFrequency'] = ncashFrequency;
        }
        if (ncashDateSelection) {
            params['ncashDateSelection'] = ncashDateSelection;
        }
        return params;
    }
    public async withdrawMoney(withdrawMoneyRequest: WithdrawMoneyRequest) {
        const url = `${this.configService.getAccountServiceUrl()}/account/${withdrawMoneyRequest.lenderId}/withdraw-money`;
        return await this.httpClient.post<any>(url, withdrawMoneyRequest).toPromise();
    }

    public async getFileByName(fileName: string): Promise<any> {    
        const authToken ='';
        const url = `${this.configService.getAccountServiceUrl()}/reports/file`;
        return await this.httpClient.get(url,
            {
                params: { 'fileName': fileName },
                headers: ({ 'Authorization': `Bearer ${authToken}` }),
                responseType: 'blob'
            }).toPromise();

    }
}
